import React from 'react';
import convertToCurrency from '../../helpers/convertToCurrency';
import CheckCircle from '../../assets/img/check-circle.png';

export default function OrderConfirmation({ customer, items = [], totals = [] }) {
  return (
    <section className="k-order-confirmation">
      <img className="k-order-confirmation__icon" src={CheckCircle} alt="" />
      <h1>Congrats, You’re all set!</h1>
      <p>In the next 24 hours, you will receive a welcome email with access to your online account.</p>
      {customer && (
        <div className="k-order-confirmation__panel k-order-confirmation__customer">
          <strong>{customer.name}</strong>
          {customer.phone && <div className="k-order-confirmation__phone">{customer.phone}</div>}
          {customer.email && <div>{customer.email}</div>}
          {customer.address && <div className="k-order-confirmation__address">{customer.address}</div>}
        </div>
      )}
      {items.map(item => (
        <div key={item.id} className="k-order-confirmation__panel k-order-confirmation__item">
          <div className="k-order-confirmation__row">
            <div>
              {item.name}
              {item.sku && <strong>SKU# {item.sku}</strong>}
            </div>
            <span>{convertToCurrency(item.price)}</span>
          </div>
          <div className="k-order-confirmation__quantity">QTY {item.quantity}</div>
        </div>
      ))}
      {totals.map(({ label, amount, bold }) => (
        <div key={label} className={`k-order-confirmation__total${bold ? ' k-order-confirmation__total--bold' : ''}`}>
          <span>{label}</span>
          <span>{convertToCurrency(amount)}</span>
        </div>
      ))}
    </section>
  );
}
